(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    const drawer = document.getElementById('CartDrawer');
    const overlay = document.getElementById('CartDrawerOverlay');
    const closeBtn = document.getElementById('CartDrawerCloseBtn');
    const itemsList = document.getElementById('CartDrawerItems');
    const emptyState = document.getElementById('CartDrawerEmpty');
    const footer = document.getElementById('CartDrawerFooter');
    const subtotalEl = document.getElementById('CartDrawerSubtotal');
    const checkTotalEl = document.getElementById('CartDrawerCheckoutTotal');
    const headerCount = document.getElementById('CartDrawerHeaderCount');

    // ── B2G1 Elements ──────────────────────────────────────────────
    const b2g1Msg = document.getElementById('CartB2G1Msg');
    const b2g1Icon = document.getElementById('CartB2G1Icon');
    const b2g1Badge = document.getElementById('CartB2G1Badge');
    const b2g1Fill = document.getElementById('CartB2G1Fill');
    const b2g1Celebration = document.getElementById('CartB2G1Celebration');
    const confettiCanvas = document.getElementById('CartCelebrationCanvas');

    let previousItemCount = 0;
    const initialBadge = document.getElementById('CartDrawerHeaderCount');
    if (initialBadge) {
      const match = initialBadge.textContent.match(/\d+/);
      if (match) previousItemCount = parseInt(match[0], 10) || 0;
    }

    if (!drawer) return;

    // ── Celebration Confetti Particle Engine ────────────────────────
    let confettiAnimationId = null;
    function fireCelebrationConfetti() {
      if (!confettiCanvas) return;
      const ctx = confettiCanvas.getContext('2d');
      const width = (confettiCanvas.width = confettiCanvas.offsetWidth || 380);
      const height = (confettiCanvas.height = confettiCanvas.offsetHeight || 140);

      const colors = ['#D4AF37', '#8B0000', '#2E8B57', '#E59837', '#FF6B6B', '#9B59B6', '#F1C40F', '#2ECC71'];
      const particles = [];
      const particleCount = 45;

      for (let i = 0; i < particleCount; i++) {
        particles.push({
          x: Math.random() * width,
          y: Math.random() * (height / 2) - 10,
          w: Math.random() * 8 + 4,
          h: Math.random() * 5 + 3,
          color: colors[Math.floor(Math.random() * colors.length)],
          vx: (Math.random() - 0.5) * 4,
          vy: Math.random() * 3 + 2,
          rotation: Math.random() * 360,
          rotationSpeed: (Math.random() - 0.5) * 10,
          opacity: 1,
        });
      }

      const startTime = performance.now();
      const duration = 2800; // 2.8 seconds

      if (confettiAnimationId) cancelAnimationFrame(confettiAnimationId);

      function renderFrame(now) {
        const elapsed = now - startTime;
        ctx.clearRect(0, 0, width, height);

        let activeParticles = 0;
        particles.forEach((p) => {
          p.x += p.vx;
          p.y += p.vy;
          p.rotation += p.rotationSpeed;
          p.vy += 0.06; // gravity

          if (elapsed > duration * 0.6) {
            p.opacity = Math.max(0, 1 - (elapsed - duration * 0.6) / (duration * 0.4));
          }

          if (p.opacity > 0 && p.y < height + 20) {
            activeParticles++;
            ctx.save();
            ctx.globalAlpha = p.opacity;
            ctx.translate(p.x, p.y);
            ctx.rotate((p.rotation * Math.PI) / 180);
            ctx.fillStyle = p.color;
            ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
            ctx.restore();
          }
        });

        if (elapsed < duration && activeParticles > 0) {
          confettiAnimationId = requestAnimationFrame(renderFrame);
        } else {
          ctx.clearRect(0, 0, width, height);
          confettiAnimationId = null;
        }
      }

      confettiAnimationId = requestAnimationFrame(renderFrame);
    }

    // ── Update B2G1 Progress State ─────────────────────────────────
    function updateB2G1Progress(count) {
      const safeCount = Math.max(0, count || 0);

      // Percentage & Fill
      let pct = 0;
      if (safeCount >= 3) {
        pct = 100;
      } else if (safeCount === 2) {
        pct = 66.6;
      } else if (safeCount === 1) {
        pct = 33.3;
      } else {
        pct = 0;
      }

      if (b2g1Fill) {
        b2g1Fill.style.width = pct + '%';
        if (safeCount >= 3) {
          b2g1Fill.classList.add('is-complete');
        } else {
          b2g1Fill.classList.remove('is-complete');
        }
      }

      // Motivational Message & Icon
      if (b2g1Msg && b2g1Icon) {
        if (safeCount === 0) {
          b2g1Icon.textContent = '🎁';
          b2g1Msg.innerHTML = '<strong>BUY 2 GET 1 FREE</strong> &mdash; Add 3 items to get 1 Free!';
        } else if (safeCount === 1) {
          b2g1Icon.textContent = '⚡';
          b2g1Msg.innerHTML = 'Add <strong>2 more items</strong> to get <strong>1 FREE</strong>!';
        } else if (safeCount === 2) {
          b2g1Icon.textContent = '🔥';
          b2g1Msg.innerHTML = 'Almost there! Add <strong>1 more item</strong> to get it <strong>FREE</strong>!';
        } else {
          b2g1Icon.textContent = '🎉';
          b2g1Msg.innerHTML = '<strong>BUY 2 GET 1 FREE UNLOCKED!</strong> 1 Item is 100% Free!';
        }
      }

      // Badge
      if (b2g1Badge) {
        if (safeCount >= 3) {
          b2g1Badge.textContent = '✓ UNLOCKED';
          b2g1Badge.classList.add('is-unlocked');
        } else {
          b2g1Badge.textContent = `${Math.min(safeCount, 3)}/3 ITEMS`;
          b2g1Badge.classList.remove('is-unlocked');
        }
      }

      // Celebration Card & Confetti
      if (b2g1Celebration) {
        if (safeCount >= 3) {
          b2g1Celebration.style.display = 'flex';
        } else {
          b2g1Celebration.style.display = 'none';
        }
      }

      // Trigger Confetti Celebration if just unlocked to 3 items
      if (safeCount >= 3 && previousItemCount < 3) {
        setTimeout(fireCelebrationConfetti, 120);
      }

      previousItemCount = safeCount;
    }

    // ── Global CartDrawer API ──────────────────────────────────────
    window.CartDrawer = {
      open: function () {
        drawer.setAttribute('aria-hidden', 'false');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.classList.add('cart-drawer-open');
        drawer.focus();
        if (previousItemCount >= 3) {
          setTimeout(fireCelebrationConfetti, 250);
        }
      },
      close: function () {
        drawer.setAttribute('aria-hidden', 'true');
        overlay.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('cart-drawer-open');
      },
      toggle: function () {
        const isHidden = drawer.getAttribute('aria-hidden') === 'true';
        if (isHidden) {
          window.CartDrawer.open();
        } else {
          window.CartDrawer.close();
        }
      },
      refresh: async function () {
        try {
          const res = await fetch('/cart.js');
          const cart = await res.json();
          renderCart(cart);
          updateHeaderBadges(cart.item_count);
        } catch (err) {
          console.error('Error fetching cart:', err);
        }
      },
      addItem: async function (variantId, quantity = 1) {
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: quantity }),
          });
          if (res.ok) {
            await window.CartDrawer.refresh();
            window.CartDrawer.open();
          } else {
            const errData = await res.json();
            alert(errData.description || 'Could not add item to cart');
          }
        } catch (err) {
          console.error('Error adding item:', err);
        }
      },
    };

    // ── Event Listeners for Open / Close ───────────────────────────
    if (closeBtn) closeBtn.addEventListener('click', window.CartDrawer.close);
    if (overlay) overlay.addEventListener('click', window.CartDrawer.close);

    // Keyboard ESC listener
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
        window.CartDrawer.close();
      }
    });

    // Delegate clicks on all elements with [data-cart-drawer-toggle] or .header__cart-link
    document.addEventListener('click', function (e) {
      const toggle = e.target.closest('[data-cart-drawer-toggle], .header__cart-link');
      if (toggle) {
        e.preventDefault();
        window.CartDrawer.open();
      }
    });

    // ── Upsell Next / Prev Carousel Controls ──────────────────────
    const upsellTrack = document.getElementById('CartDrawerUpsellTrack');
    const upsellPrev = document.getElementById('CartDrawerUpsellPrev');
    const upsellNext = document.getElementById('CartDrawerUpsellNext');

    if (upsellTrack && upsellPrev && upsellNext) {
      upsellPrev.addEventListener('click', () => {
        upsellTrack.scrollBy({ left: -220, behavior: 'smooth' });
      });
      upsellNext.addEventListener('click', () => {
        upsellTrack.scrollBy({ left: 220, behavior: 'smooth' });
      });
    }

    // ── Global Add to Cart Form Interception ────────────────────────
    document.addEventListener('submit', async function (e) {
      const form = e.target.closest('form[action*="/cart/add"]');
      if (form && !form.hasAttribute('data-no-ajax')) {
        e.preventDefault();
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.classList.add('is-loading');

        try {
          const formData = new FormData(form);
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { Accept: 'application/json' },
          });
          if (res.ok) {
            await window.CartDrawer.refresh();
            window.CartDrawer.open();
          } else {
            const err = await res.json();
            alert(err.description || 'Could not add item to bag');
          }
        } catch (err) {
          console.error('Error in AJAX form submit:', err);
        } finally {
          if (submitBtn) submitBtn.classList.remove('is-loading');
        }
      }
    });

    // ── Stepper and Remove Actions inside Drawer ──────────────────
    drawer.addEventListener('click', async function (e) {
      // 1. Remove Item
      const removeBtn = e.target.closest('[data-remove-key]');
      if (removeBtn) {
        e.preventDefault();
        const key = removeBtn.getAttribute('data-remove-key');
        await updateCartItem(key, 0);
        return;
      }

      // 2. Stepper Button (+ / -)
      const stepperBtn = e.target.closest('[data-stepper]');
      if (stepperBtn) {
        e.preventDefault();
        const key = stepperBtn.getAttribute('data-key');
        const currentQty = parseInt(stepperBtn.getAttribute('data-qty'), 10) || 1;
        const type = stepperBtn.getAttribute('data-stepper');
        const newQty = type === 'plus' ? currentQty + 1 : currentQty - 1;
        await updateCartItem(key, newQty);
        return;
      }

      // 3. Upsell Add Button
      const upsellBtn = e.target.closest('[data-upsell-add]');
      if (upsellBtn) {
        e.preventDefault();
        const card = upsellBtn.closest('.cart-drawer__upsell-card');
        const select = card ? card.querySelector('[data-upsell-select]') : null;
        const variantId = select ? select.value : upsellBtn.getAttribute('data-variant-id');

        upsellBtn.classList.add('is-loading');
        upsellBtn.textContent = '...';
        await window.CartDrawer.addItem(variantId, 1);
        upsellBtn.classList.remove('is-loading');
        upsellBtn.textContent = '✓ Added';
        setTimeout(() => {
          upsellBtn.textContent = '+ Add';
        }, 1500);
      }
    });

    // ── AJAX Cart Update Helper ────────────────────────────────────
    async function updateCartItem(key, quantity) {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity }),
        });
        const cart = await res.json();
        renderCart(cart);
        updateHeaderBadges(cart.item_count);
      } catch (err) {
        console.error('Error changing cart item:', err);
      }
    }

    // ── Currency Formatter ─────────────────────────────────────────
    function formatMoney(cents) {
      if (typeof cents !== 'number') return 'Rs. 0.00';
      const amount = (cents / 100).toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return 'Rs. ' + amount;
    }

    // ── Update Header & Badges ─────────────────────────────────────
    function updateHeaderBadges(count) {
      const badges = document.querySelectorAll('.header__cart-badge, .mobile-drawer__cart-counter');
      badges.forEach((b) => {
        b.textContent = count;
        b.style.display = count > 0 ? '' : 'none';
      });
      if (headerCount) {
        headerCount.textContent = `(${count})`;
        headerCount.style.display = count > 0 ? '' : 'none';
      }
    }

    // ── Re-render Cart DOM Dynamically ─────────────────────────────
    function renderCart(cart) {
      if (!cart) return;

      // Update B2G1 Status Progress Bar & Celebration
      updateB2G1Progress(cart.item_count);

      // Toggle Empty vs Filled
      if (cart.item_count === 0) {
        if (itemsList) itemsList.style.display = 'none';
        if (footer) footer.style.display = 'none';
        if (emptyState) emptyState.style.display = 'flex';
      } else {
        if (emptyState) emptyState.style.display = 'none';
        if (itemsList) itemsList.style.display = 'flex';
        if (footer) footer.style.display = 'block';
      }

      // Update Subtotals
      const totalFormatted = formatMoney(cart.total_price);
      if (subtotalEl) subtotalEl.textContent = totalFormatted;
      if (checkTotalEl) checkTotalEl.textContent = totalFormatted;

      // Update Offer Details & Breakdown
      const allUnitPrices = [];
      let totalMRP = 0;
      if (cart.items && cart.items.length > 0) {
        cart.items.forEach((item) => {
          const itemPrice = item.final_price || item.price || 0;
          const origPrice = item.original_price && item.original_price > itemPrice ? item.original_price : itemPrice;
          totalMRP += origPrice * item.quantity;
          for (let i = 0; i < item.quantity; i++) {
            allUnitPrices.push(itemPrice);
          }
        });
      }
      allUnitPrices.sort((a, b) => a - b);

      const freeCount = Math.floor(cart.item_count / 3);
      let b2g1Discount = 0;
      for (let i = 0; i < freeCount; i++) {
        b2g1Discount += allUnitPrices[i] || 0;
      }

      const totalMRPEl = document.getElementById('CartDrawerTotalMRP');
      const itemsCountSummaryEl = document.getElementById('CartDrawerItemsCountSummary');
      const b2g1RowEl = document.getElementById('CartDrawerB2G1Row');
      const b2g1SavingEl = document.getElementById('CartDrawerB2G1Saving');
      const offerTitleEl = document.getElementById('CartDrawerOfferTitle');
      const offerStatusBadgeEl = document.getElementById('CartDrawerOfferStatusBadge');
      const offerSummaryEl = document.getElementById('CartDrawerOfferSummary');

      if (offerSummaryEl) {
        offerSummaryEl.style.display = cart.item_count > 0 ? 'block' : 'none';
      }

      if (itemsCountSummaryEl) itemsCountSummaryEl.textContent = cart.item_count;
      if (totalMRPEl) totalMRPEl.textContent = formatMoney(cart.total_price + b2g1Discount);

      if (cart.item_count >= 3) {
        if (offerTitleEl) offerTitleEl.textContent = 'Buy 2 Get 1 FREE Applied';
        if (offerStatusBadgeEl) {
          offerStatusBadgeEl.textContent = '✓ APPLIED';
          offerStatusBadgeEl.classList.add('is-applied');
        }
        if (b2g1RowEl) b2g1RowEl.style.display = 'flex';
        if (b2g1SavingEl) {
          b2g1SavingEl.textContent = b2g1Discount > 0 ? `-${formatMoney(b2g1Discount)}` : 'FREE';
        }
      } else {
        const remaining = 3 - cart.item_count;
        if (offerTitleEl) offerTitleEl.textContent = 'Buy 2 Get 1 FREE Offer';
        if (offerStatusBadgeEl) {
          offerStatusBadgeEl.textContent = `Add ${remaining} to unlock`;
          offerStatusBadgeEl.classList.remove('is-applied');
        }
        if (b2g1RowEl) b2g1RowEl.style.display = 'none';
      }

      // Rebuild Items List
      if (itemsList && cart.items) {
        itemsList.innerHTML = cart.items
          .map((item, idx) => {
            const comparePriceHtml =
              item.original_price > item.final_price
                ? `<span class="cart-drawer__item-compare">${formatMoney(item.original_price)}</span>`
                : '';
            const variantHtml =
              item.variant_title && item.variant_title !== 'Default Title'
                ? `<div class="cart-drawer__item-variant"><span class="cart-drawer__variant-pill">${item.variant_title}</span></div>`
                : '';

            return `
            <div class="cart-drawer__item" data-item-key="${item.key}" data-line="${idx + 1}">
              <div class="cart-drawer__item-thumb">
                <a href="${item.url}">
                  ${
                    item.image
                      ? `<img src="${item.image}" alt="${item.title}" loading="lazy" width="85" height="105" class="cart-drawer__item-img">`
                      : `<div class="cart-drawer__item-placeholder"></div>`
                  }
                </a>
              </div>

              <div class="cart-drawer__item-details">
                <div class="cart-drawer__item-header">
                  <a href="${item.url}" class="cart-drawer__item-title">${item.product_title}</a>
                  <div class="cart-drawer__item-pricing">
                    ${comparePriceHtml}
                    <span class="cart-drawer__item-price">${formatMoney(item.final_price)}</span>
                  </div>
                </div>

                ${variantHtml}

                <div class="cart-drawer__item-bottom">
                  <button
                    type="button"
                    class="cart-drawer__item-remove"
                    data-remove-key="${item.key}"
                    aria-label="Remove ${item.title}"
                  >
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="3 6 5 6 21 6"></polyline>
                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                      <line x1="10" y1="11" x2="10" y2="17"></line>
                      <line x1="14" y1="11" x2="14" y2="17"></line>
                    </svg>
                  </button>

                  <div class="cart-drawer__stepper">
                    <button
                      type="button"
                      class="cart-drawer__stepper-btn"
                      data-stepper="minus"
                      data-key="${item.key}"
                      data-qty="${item.quantity}"
                      aria-label="Decrease quantity"
                    >&minus;</button>
                    <span class="cart-drawer__stepper-val">${item.quantity}</span>
                    <button
                      type="button"
                      class="cart-drawer__stepper-btn"
                      data-stepper="plus"
                      data-key="${item.key}"
                      data-qty="${item.quantity}"
                      aria-label="Increase quantity"
                    >&#43;</button>
                  </div>
                </div>
              </div>
            </div>
          `;
          })
          .join('');
      }

      // Filter out upsell suggestions that are already in cart
      const currentCartProductIds = (cart.items || []).map((item) => String(item.product_id));
      const upsellCards = document.querySelectorAll('.cart-drawer__upsell-card[data-product-id]');
      let visibleUpsells = 0;
      upsellCards.forEach((card) => {
        const prodId = card.getAttribute('data-product-id');
        if (currentCartProductIds.includes(prodId)) {
          card.style.display = 'none';
        } else {
          card.style.display = 'flex';
          visibleUpsells++;
        }
      });
      const upsellSection = document.getElementById('CartDrawerUpsell');
      if (upsellSection) {
        upsellSection.style.display = visibleUpsells > 0 ? 'block' : 'none';
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["featured-product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__featuredProductCardInit) return;
    window.__featuredProductCardInit = true;

    // ── Quick add (+) ─────────────────────────────────────────────
    async function quickAdd(btn) {
      const variantId = btn.getAttribute('data-variant-id');
      if (!variantId || btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;

      const wrap = btn.closest('.featured-card__quick-wrap');
      const toast = wrap && wrap.querySelector('[data-quick-add-toast]');
      const status = wrap && wrap.querySelector('[data-quick-add-status]');
      const card = btn.closest('.featured-card');

      clearTimeout(btn._quickAddReset);
      if (wrap) wrap.classList.add('is-active');
      btn.classList.remove('is-error');
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');

      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');

        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        showToast(toast, 'Added to cart', false);
        if (status) status.textContent = 'Added to cart';

        const openDrawerHost = btn.closest('[data-open-drawer-on-add]');
        const openDrawer = Boolean(openDrawerHost && openDrawerHost.dataset.openDrawerOnAdd === 'true');
        flyToCart(card).then(() => refreshCart(openDrawer));
      } catch (err) {
        console.error('[ProductCard] Quick add failed:', err);
        btn.classList.remove('is-loading');
        void btn.offsetWidth; // restart the shake animation
        btn.classList.add('is-error');
        const message = /sold out|already|available/i.test(err.message) ? 'Out of stock' : 'Try again';
        showToast(toast, message, true);
        if (status) status.textContent = err.message;
      } finally {
        btn.removeAttribute('aria-busy');
        btn._quickAddReset = setTimeout(() => {
          btn.classList.remove('is-added', 'is-error');
          if (wrap) wrap.classList.remove('is-active');
          if (toast) toast.classList.remove('is-visible');
          if (status) status.textContent = '';
        }, 2200);
      }
    }

    function showToast(toast, text, isError) {
      if (!toast) return;
      toast.textContent = text;
      toast.classList.toggle('is-error', isError);
      toast.classList.add('is-visible');
    }

    // Animate a copy of the product image into the header cart icon
    function flyToCart(card) {
      return new Promise((resolve) => {
        const img = card && card.querySelector('.featured-card__img--primary');
        const cartIcon = [document.getElementById('HeaderCartBtn'), ...document.querySelectorAll('[data-cart-drawer-toggle]')]
          .find((el) => el && el.getBoundingClientRect().width > 0);
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!img || !cartIcon || reduceMotion || typeof img.animate !== 'function') return resolve();

        const from = img.getBoundingClientRect();
        const to = cartIcon.getBoundingClientRect();
        const size = Math.min(from.width, 120);

        const flyer = img.cloneNode(false);
        flyer.removeAttribute('srcset');
        flyer.removeAttribute('loading');
        flyer.src = img.currentSrc || img.src;
        flyer.className = 'featured-fly-img';
        flyer.alt = '';
        Object.assign(flyer.style, {
          left: `${from.left + from.width / 2 - size / 2}px`,
          top: `${from.top + from.height / 2 - (size * 4) / 3 / 2}px`,
          width: `${size}px`,
          height: `${(size * 4) / 3}px`,
        });
        document.body.appendChild(flyer);

        const dx = to.left + to.width / 2 - (from.left + from.width / 2);
        const dy = to.top + to.height / 2 - (from.top + from.height / 2);

        const animation = flyer.animate(
          [
            { transform: 'translate(0, 0) scale(1)', opacity: 1 },
            { transform: `translate(${dx * 0.45}px, ${dy * 0.45 - 60}px) scale(0.55)`, opacity: 0.95, offset: 0.45 },
            { transform: `translate(${dx}px, ${dy}px) scale(0.08)`, opacity: 0.3 },
          ],
          { duration: 800, easing: 'cubic-bezier(0.55, 0, 0.35, 1)' }
        );

        animation.onfinish = () => {
          flyer.remove();
          cartIcon.classList.remove('featured-cart-bump');
          void cartIcon.offsetWidth;
          cartIcon.classList.add('featured-cart-bump');
          setTimeout(() => cartIcon.classList.remove('featured-cart-bump'), 600);
          resolve();
        };
      });
    }

    async function refreshCart(openDrawer) {
      if (window.CartDrawer && typeof window.CartDrawer.refresh === 'function') {
        await window.CartDrawer.refresh();
        if (openDrawer && typeof window.CartDrawer.open === 'function') window.CartDrawer.open();
      }
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }

    // ── Buy now: GoKwik checkout for this card's variant ──────────
    // The button carries data-gokwik-processed so the GoKwik auto-scanner leaves it alone
    // (it would otherwise pick the variant from the page's product form, not this card).
    function waitForGoKwikBuyNow(timeout) {
      return new Promise((resolve) => {
        if (typeof window.onBuyNowClick === 'function') return resolve(true);
        const started = Date.now();
        const poll = setInterval(() => {
          if (typeof window.onBuyNowClick === 'function') {
            clearInterval(poll);
            resolve(true);
          } else if (Date.now() - started >= timeout) {
            clearInterval(poll);
            resolve(false);
          }
        }, 100);
      });
    }

    async function buyNow(btn, e) {
      const variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');

      try {
        const gokwikReady = await waitForGoKwikBuyNow(4000);
        if (gokwikReady) {
          window.onBuyNowClick(e, false, [{ id: variantId, quantity: 1 }]);
          return;
        }
        console.warn('[ProductCard] GoKwik not available, falling back to native checkout');
      } catch (err) {
        console.error('[ProductCard] GoKwik error:', err);
      } finally {
        setTimeout(() => {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        }, 1500);
      }

      window.location.href = `/cart/${variantId}:1`;
    }

    document.addEventListener('click', (e) => {
      const quickBtn = e.target.closest('[data-quick-add-btn]');
      if (quickBtn) {
        e.preventDefault();
        e.stopPropagation();
        quickAdd(quickBtn);
        return;
      }

      const buyBtn = e.target.closest('[data-featured-buy-now]');
      if (buyBtn && !buyBtn.disabled && !buyBtn.classList.contains('is-loading')) {
        e.preventDefault();
        e.stopPropagation();
        buyNow(buyBtn, e);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-lightbox"] && !Shopify.designMode) return;
  try {
    (() => {
    const MIN_SCALE = 1;
    const MAX_SCALE = 4;
    const ZOOM_STEP = 0.75;
    const DOUBLE_TAP_ZOOM = 2.5;

    class ProductLightbox {
      constructor(root) {
        this.root = root;
        this.stage = root.querySelector('[data-lightbox-stage]');
        this.slides = Array.from(root.querySelectorAll('[data-lightbox-slide]'));
        this.prevBtn = root.querySelector('[data-lightbox-prev]');
        this.nextBtn = root.querySelector('[data-lightbox-next]');
        this.closeBtn = root.querySelector('[data-lightbox-close]');
        this.zoomInBtn = root.querySelector('[data-lightbox-zoom-in]');
        this.zoomOutBtn = root.querySelector('[data-lightbox-zoom-out]');
        this.status = root.querySelector('[data-lightbox-status]');

        this.index = 0;
        this.scale = 1;
        this.x = 0;
        this.y = 0;
        this.pointers = new Map();
        this.lastTap = null;
        this.returnFocus = null;

        this.onKeydown = this.onKeydown.bind(this);
        this.bindEvents();
      }

      get image() {
        return this.slides[this.index] && this.slides[this.index].querySelector('[data-lightbox-image]');
      }

      bindEvents() {
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.index + 1));
        this.closeBtn.addEventListener('click', () => this.close());
        this.zoomInBtn.addEventListener('click', () => this.zoomBy(ZOOM_STEP));
        this.zoomOutBtn.addEventListener('click', () => this.zoomBy(-ZOOM_STEP));

        this.stage.addEventListener('pointerdown', (e) => this.onPointerDown(e));
        this.stage.addEventListener('pointermove', (e) => this.onPointerMove(e));
        this.stage.addEventListener('pointerup', (e) => this.onPointerUp(e));
        this.stage.addEventListener('pointercancel', (e) => this.onPointerUp(e));
        this.stage.addEventListener('wheel', (e) => this.onWheel(e), { passive: false });
      }

      open(index) {
        clearTimeout(this.closeTimer);
        this.returnFocus = document.activeElement;
        this.root.hidden = false;
        document.documentElement.classList.add('product-lightbox-open');
        document.addEventListener('keydown', this.onKeydown);
        this.go(index, true);
        requestAnimationFrame(() => this.root.classList.add('is-open'));
        this.closeBtn.focus({ preventScroll: true });
      }

      close() {
        this.root.classList.remove('is-open');
        document.removeEventListener('keydown', this.onKeydown);
        clearTimeout(this.tapTimer);
        this.closeTimer = setTimeout(() => {
          this.root.hidden = true;
          document.documentElement.classList.remove('product-lightbox-open');
          this.resetZoom(false);
        }, 250);
        if (this.returnFocus && typeof this.returnFocus.focus === 'function') {
          this.returnFocus.focus({ preventScroll: true });
        }
      }

      go(index, instant) {
        const total = this.slides.length;
        if (!total) return;
        this.resetZoom(false);
        this.index = (index + total) % total;
        this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.index));
        if (this.status) this.status.textContent = `Image ${this.index + 1} of ${total}`;
        if (!instant) this.preloadNeighbours();
      }

      preloadNeighbours() {
        [this.index - 1, this.index + 1].forEach((i) => {
          const slide = this.slides[(i + this.slides.length) % this.slides.length];
          const img = slide && slide.querySelector('img');
          if (img) img.loading = 'eager';
        });
      }

      // ── Zoom & pan ───────────────────────────────────────────────
      setTransform(animate) {
        const img = this.image;
        if (!img) return;
        img.classList.toggle('is-animating', Boolean(animate));
        img.style.transform = `translate3d(${this.x}px, ${this.y}px, 0) scale(${this.scale})`;
        this.root.classList.toggle('is-zoomed', this.scale > 1);
        this.zoomOutBtn.disabled = this.scale <= MIN_SCALE;
        this.zoomInBtn.disabled = this.scale >= MAX_SCALE;
      }

      clampPan() {
        const img = this.image;
        if (!img) return;
        const stageRect = this.stage.getBoundingClientRect();
        const maxX = Math.max(0, (img.offsetWidth * this.scale - stageRect.width) / 2);
        const maxY = Math.max(0, (img.offsetHeight * this.scale - stageRect.height) / 2);
        this.x = Math.min(maxX, Math.max(-maxX, this.x));
        this.y = Math.min(maxY, Math.max(-maxY, this.y));
      }

      // Zoom keeping the given stage point (relative to stage centre) fixed
      zoomTo(newScale, originX = 0, originY = 0, animate = true) {
        const scale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, newScale));
        const ratio = scale / this.scale;
        this.x = originX - (originX - this.x) * ratio;
        this.y = originY - (originY - this.y) * ratio;
        this.scale = scale;
        if (scale === MIN_SCALE) {
          this.x = 0;
          this.y = 0;
        }
        this.clampPan();
        this.setTransform(animate);
      }

      zoomBy(delta) {
        this.zoomTo(this.scale + delta);
      }

      resetZoom(animate) {
        const img = this.image;
        this.scale = 1;
        this.x = 0;
        this.y = 0;
        if (img) this.setTransform(animate);
      }

      stagePoint(clientX, clientY) {
        const rect = this.stage.getBoundingClientRect();
        return { x: clientX - rect.left - rect.width / 2, y: clientY - rect.top - rect.height / 2 };
      }

      onWheel(e) {
        e.preventDefault();
        const p = this.stagePoint(e.clientX, e.clientY);
        const factor = e.deltaY < 0 ? 1.15 : 1 / 1.15;
        this.zoomTo(this.scale * factor, p.x, p.y, false);
      }

      // ── Pointer handling: drag-pan, swipe, pinch, double-tap ─────
      onPointerDown(e) {
        if (e.button !== undefined && e.button !== 0) return;
        this.stage.setPointerCapture(e.pointerId);
        this.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

        if (this.pointers.size === 1) {
          // Record the target now: with pointer capture, pointerup always targets the stage
          const onImage = Boolean(e.target.closest('[data-lightbox-image]'));
          this.gesture = { startX: e.clientX, startY: e.clientY, baseX: this.x, baseY: this.y, moved: false, onImage };
        } else if (this.pointers.size === 2) {
          const [a, b] = Array.from(this.pointers.values());
          const mid = this.stagePoint((a.x + b.x) / 2, (a.y + b.y) / 2);
          this.pinch = { startDist: Math.hypot(a.x - b.x, a.y - b.y), startScale: this.scale, mid };
          this.gesture = null;
        }
      }

      onPointerMove(e) {
        if (!this.pointers.has(e.pointerId)) return;
        this.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

        if (this.pinch && this.pointers.size === 2) {
          const [a, b] = Array.from(this.pointers.values());
          const dist = Math.hypot(a.x - b.x, a.y - b.y);
          this.zoomTo((this.pinch.startScale * dist) / this.pinch.startDist, this.pinch.mid.x, this.pinch.mid.y, false);
          return;
        }

        const g = this.gesture;
        if (!g) return;
        const dx = e.clientX - g.startX;
        const dy = e.clientY - g.startY;
        if (Math.abs(dx) > 4 || Math.abs(dy) > 4) g.moved = true;
        if (!g.moved) return;

        this.root.classList.add('is-dragging');
        if (this.scale > 1) {
          this.x = g.baseX + dx;
          this.y = g.baseY + dy;
          this.clampPan();
        } else {
          // Swipe preview: follow the finger horizontally
          this.x = dx;
          this.y = 0;
        }
        this.setTransform(false);
      }

      onPointerUp(e) {
        if (!this.pointers.has(e.pointerId)) return;
        this.pointers.delete(e.pointerId);
        this.root.classList.remove('is-dragging');

        if (this.pinch) {
          if (this.pointers.size < 2) this.pinch = null;
          this.gesture = null;
          return;
        }

        const g = this.gesture;
        this.gesture = null;
        if (!g) return;

        const dx = e.clientX - g.startX;

        if (this.scale === 1 && g.moved) {
          if (Math.abs(dx) > 60 && this.slides.length > 1) {
            this.go(this.index + (dx < 0 ? 1 : -1));
          } else {
            this.resetZoom(true);
          }
          return;
        }

        if (g.moved) return;

        // Tap: double-tap toggles zoom; single tap on empty space closes
        const now = Date.now();
        if (this.lastTap && now - this.lastTap.time < 300 && Math.hypot(e.clientX - this.lastTap.x, e.clientY - this.lastTap.y) < 30) {
          clearTimeout(this.tapTimer);
          this.lastTap = null;
          if (this.scale > 1) {
            this.resetZoom(true);
          } else {
            const p = this.stagePoint(e.clientX, e.clientY);
            this.zoomTo(DOUBLE_TAP_ZOOM, p.x, p.y, true);
          }
          return;
        }

        this.lastTap = { time: now, x: e.clientX, y: e.clientY };
        if (!g.onImage && this.scale === 1) {
          this.tapTimer = setTimeout(() => this.close(), 300);
        }
      }

      onKeydown(e) {
        switch (e.key) {
          case 'Escape':
            this.close();
            break;
          case 'ArrowLeft':
            if (this.scale === 1) this.go(this.index - 1);
            break;
          case 'ArrowRight':
            if (this.scale === 1) this.go(this.index + 1);
            break;
          case '+':
          case '=':
            this.zoomBy(ZOOM_STEP);
            break;
          case '-':
            this.zoomBy(-ZOOM_STEP);
            break;
          case 'Tab': {
            // Keep focus inside the viewer
            const focusable = Array.from(this.root.querySelectorAll('button:not(:disabled)'));
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (e.shiftKey && document.activeElement === first) {
              e.preventDefault();
              last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
              e.preventDefault();
              first.focus();
            }
            break;
          }
          default:
            return;
        }
      }
    }

    function getLightbox(sectionId) {
      const root = document.getElementById(`ProductLightbox-${sectionId}`);
      if (!root) return null;
      if (!root._lightbox) {
        // Move to <body> so no transformed ancestor can break position: fixed
        if (root.parentElement !== document.body) document.body.appendChild(root);
        root._lightbox = new ProductLightbox(root);
      }
      return root._lightbox;
    }

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-lightbox-open]');
      if (!trigger) return;
      const section = trigger.closest('[data-section-id]');
      const lightbox = section && getLightbox(section.dataset.sectionId);
      if (!lightbox) return;
      e.preventDefault();
      lightbox.open(parseInt(trigger.dataset.lightboxIndex, 10) || 0);
    });

    // Theme editor: drop a stale viewer left in <body> when the section re-renders
    document.addEventListener('shopify:section:unload', (e) => {
      const stale = document.getElementById(`ProductLightbox-${e.detail.sectionId}`);
      if (stale && stale.parentElement === document.body) stale.remove();
      document.documentElement.classList.remove('product-lightbox-open');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-modal"] && !Shopify.designMode) return;
  try {
    class SearchModalController {
    constructor() {
      this.drawer  = document.getElementById('SearchModal');
      this.overlay = document.getElementById('SearchDrawerOverlay');
      this.toggleBtns = document.querySelectorAll('[data-search-modal-toggle]');
      this.closeBtn = document.getElementById('SearchModalCloseBtn');
      this.form  = document.getElementById('SearchModalForm');
      this.input = document.getElementById('SearchModalInput');
      this.body  = document.getElementById('SearchModalBody');
      this.defaultContent = document.getElementById('SearchModalDefaultContent');
      this.liveResults = document.getElementById('SearchModalLiveResults');
      this.liveGrid    = document.getElementById('SearchModalLiveGrid');
      this.emptyState  = document.getElementById('SearchModalEmptyState');
      this.footer      = document.getElementById('SearchModalFooter');
      this.viewAllLink = document.getElementById('SearchModalViewAllLink');
      this.recentlyViewedSection = document.getElementById('RecentlyViewedSection');
      this.recentlyViewedGrid    = document.getElementById('RecentlyViewedGrid');
      this.clearRecentBtn        = document.getElementById('ClearRecentlyViewedBtn');

      this.storageKey   = 'recently_viewed_products';
      this.debounceTimer = null;

      if (!this.drawer) return;

      this.initEvents();
      this.loadRecentlyViewed();
    }

    initEvents() {
      this.toggleBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer.getAttribute('aria-hidden') === 'false') {
          this.close();
        }
      });

      if (this.input) {
        this.input.addEventListener('input', (e) => {
          const query = e.target.value.trim();
          this.handleSearchInput(query);
        });
      }

      if (this.clearRecentBtn) {
        this.clearRecentBtn.addEventListener('click', () => {
          localStorage.removeItem(this.storageKey);
          if (this.recentlyViewedSection) {
            this.recentlyViewedSection.style.display = 'none';
          }
        });
      }
    }

    open() {
      this.drawer.setAttribute('aria-hidden', 'false');
      this.overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('search-drawer-open');
      this.loadRecentlyViewed();
      if (this.input) {
        setTimeout(() => this.input.focus(), 60);
      }
    }

    close() {
      this.drawer.setAttribute('aria-hidden', 'true');
      this.overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('search-drawer-open');
      if (this.input) this.input.value = '';
      this.showDefaultContent();
    }

    showDefaultContent() {
      if (this.liveResults)   this.liveResults.style.display = 'none';
      if (this.defaultContent) this.defaultContent.style.display = 'block';
    }

    showLiveResults() {
      if (this.defaultContent) this.defaultContent.style.display = 'none';
      if (this.liveResults)    this.liveResults.style.display = 'block';
    }

    loadRecentlyViewed() {
      try {
        const stored = localStorage.getItem(this.storageKey);
        if (!stored) return;
        const items = JSON.parse(stored);
        if (!Array.isArray(items) || items.length === 0) return;

        if (this.recentlyViewedGrid) {
          this.recentlyViewedGrid.innerHTML = items.slice(0, 4).map(item => `
            <div class="search-drawer__card">
              <a href="${item.url}" class="search-drawer__card-image-wrap">
                ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy" width="200" height="267">` : '<div class="search-drawer__card-no-image"></div>'}
              </a>
              <div class="search-drawer__card-info">
                <a href="${item.url}" class="search-drawer__card-title">${item.title}</a>
                <div class="search-drawer__card-pricing">
                  ${item.has_compare_price && item.compare_at_price ? `<s class="search-drawer__card-compare">${item.compare_at_price}</s>` : ''}
                  <span class="search-drawer__card-price">${item.price}</span>
                </div>
              </div>
            </div>
          `).join('');

          if (this.recentlyViewedSection) {
            this.recentlyViewedSection.style.display = 'flex';
          }
        }
      } catch (err) {
        console.warn('Could not load recently viewed items', err);
      }
    }

    handleSearchInput(query) {
      clearTimeout(this.debounceTimer);
      if (!query || query.length === 0) {
        this.showDefaultContent();
        return;
      }
      this.debounceTimer = setTimeout(() => {
        this.fetchSearchResults(query);
      }, 200);
    }

    async fetchSearchResults(query) {
      this.showLiveResults();
      try {
        const searchUrl = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`;
        const res  = await fetch(searchUrl);
        const data = await res.json();
        const products = data.resources?.results?.products || [];

        if (products.length === 0) {
          if (this.liveGrid) this.liveGrid.innerHTML = '';
          if (this.emptyState) {
            this.emptyState.innerHTML = `<p>No results found for "<strong>${this.escapeHtml(query)}</strong>"</p>`;
            this.emptyState.style.display = 'block';
          }
          if (this.footer) this.footer.style.display = 'none';
        } else {
          if (this.emptyState) this.emptyState.style.display = 'none';
          if (this.liveGrid) {
            this.liveGrid.innerHTML = products.map(prod => `
              <div class="search-drawer__card">
                <a href="${prod.url}" class="search-drawer__card-image-wrap">
                  ${prod.image ? `<img src="${prod.image}" alt="${this.escapeHtml(prod.title)}" loading="lazy" width="200" height="267">` : '<div class="search-drawer__card-no-image"></div>'}
                </a>
                <div class="search-drawer__card-info">
                  <a href="${prod.url}" class="search-drawer__card-title">${this.escapeHtml(prod.title)}</a>
                  <div class="search-drawer__card-pricing">
                    ${prod.compare_at_price_max && parseFloat(prod.compare_at_price_max) > parseFloat(prod.price) ? `<s class="search-drawer__card-compare">${prod.compare_at_price_max}</s>` : ''}
                    <span class="search-drawer__card-price">${prod.price}</span>
                  </div>
                </div>
              </div>
            `).join('');
          }

          if (this.footer && this.viewAllLink) {
            this.viewAllLink.href = `/search?q=${encodeURIComponent(query)}`;
            this.viewAllLink.innerHTML = `View all results for "${this.escapeHtml(query)}" &rarr;`;
            this.footer.style.display = 'flex';
          }
        }
      } catch (err) {
        console.error('Search fetch error:', err);
      }
    }

    escapeHtml(str) {
      if (!str) return '';
      return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new SearchModalController());
  } else {
    new SearchModalController();
  }
  } catch(e) { console.error(e); }
})();

})();
